module.exports = __webpack_public_path__ + "img/nextgenlogo.c9c86090.png";